// extracted by mini-css-extract-plugin
var _1 = "resource-metadata___VSdOi";
var _2 = "resource-metadata-item___JtjMw";
export { _1 as "resource-metadata", _2 as "resource-metadata-item" }
